<!--
 * @Author: your name
 * @Date: 2020-12-11 15:04:25
 * @LastEditTime: 2022-06-30 14:38:11
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-user/pay/index.vue
-->
<style scoped lang="sass">
.app_container
  display: flex
  flex-direction: column
  align-items: center
  padding: 38px 60px 0

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)
    border: none

  .van-button--disabled
    opacity: 1
    background-color: rgb(221, 221, 221) !important

.submit
  height: 56px
  width: 100%
  font-size: 15px
  border-radius: 5px !important

.icon_container
  display: flex
  justify-content: center
  align-items: center
  height: 70px
  width: 70px
  background-color: #EFEFF0
  border-radius: 50%

.icon
  height: 43px

.title
  padding-top: 23px
  padding-bottom: 28px
  font-size: 15px
  color: var(--menu-primary-text-colour)

.code
  display: flex !important
  justify-content: space-between !important
  align-items: center !important
  height: 54px !important
  width: 100% !important
  margin-bottom: 26px !important
  flex-direction: row !important
  flex-wrap: nowrap !important

::v-deep
  .__otp_input_component
    height: 54PX
    width: 54PX
    margin: 0 5PX
</style>

<template lang="pug">
.app_container
  .icon_container
    img.icon(:src="lockSrc")
  .title.b.o7 {{ title }}
  otp-input.code(v-model="code")
  van-button.submit.b.ls1(
    type="primary"
    :disabled="disabled"
    @click="submitButton"
  ) {{ t('submit', 'SUBMIT') }}
  py-loading(
    :showLoading="loading"
  )

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { loading } from 'utils/decorators'
import { payOrder } from 'api/product'

import { tab_insufficient_fund_not_tab_owner, tab_wrong_date, } from 'utils/message'

import { _formatOpenDate } from 'utils/format'
import { t } from '@/utils/language'

@Component({
  created() {
    this._getInfo()
  },

  mounted() {
    this.checkShowNotify()
  },

  watch: {
    code(val) {
      this.disabled = val.length !== 4
    }
  }
})
class TabUserPay extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  notifyMessage = t('no_tips_with_tab', 'Sorry, we don\'t accept tips when paying with a tab. Your tip will not be added.')
  hasPaidTip = false
  orderId = ''
  orderNo = ''
  disabled = true
  loading = false
  lockSrc = require('@/assets/pay-methods/tab-user-lock.png')
  title = t('enter_tab_code', 'Please enter tab code')
  code = ''

  _clearProductListAndUnpaidOrder() {
    this.$store.commit('clearProductList')
    this.$store.commit('clearDiscounts')
    // this.$store.commit('clearUnpaidOrder', this.venueId)
  }

  checkShowNotify() {
    if (this.hasPaidTip) {
      this.$createNotify({
        $props: {
          message: this.notifyMessage,
          type: 'danger',
        },
      }).show()
    }
  }

  @loading('loading')
  async submitButton() {
    try {
      const res = await this.payTabOrder()
      this._clearProductListAndUnpaidOrder()
      this._jumpToTabOrderReceived()
    } catch (error) {
      if (error === 'tab_insufficient_fund_not_tab_owner') {
        this._showTabDialog(tab_insufficient_fund_not_tab_owner)
      } else if (error?.message === 'tab_not_start') {
        this._showTabDialog(tab_wrong_date, _formatOpenDate(error.tabOpenTime))
      } else {
        // this._showTabDialog(no_tab)
      }
    }
  }

  _showTabDialog(props, openTime = '') {
    this.$createTabMessageDialog({
      $props: {
        ...props,
        insertStr: openTime
      },
    }).show()
  }

  _jumpToTabOrderReceived() {
    const query = {
      orderId: this.orderId,
      orderNo: this.orderNo,
      isMarketing: 1
    }
    this.$router.push({
      path: `/v/${this.$store.state.venueId}/tab-order-received/${this.orderId}`,
      query,
    })
  }

  async payTabOrder() {
    const res = await payOrder({
      id: this.orderId,
      paymentInfo: {
        type: 'payWithTab',
        tabCode: this.code
      }
    })
  }

  _getInfo() {
    let hasPaidTip = this.$route.query.hasPaidTip
    if (typeof hasPaidTip === 'string') hasPaidTip = Boolean(hasPaidTip === 'true')
    this.hasPaidTip = hasPaidTip
    this.orderId = this.$route.query.orderId
    this.orderNo = this.$route.query.orderNo
  }
}

export default TabUserPay
</script>
